import { Component, Inject } from '@angular/core';
import { LcbFilaProdEmb } from '../../../models/lcb-fila-produtivo-embalagem';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RecebimentoService } from '../../../../../shared/services/recebimento.service';
import { ToastService } from '../../../../../shared/services/toast.service';
import { DateHelper } from '../../../../../shared/helpers/date.helper';
import { ToastState as ts } from '../../../../../shared/enums/toast-state.enum';

import { TegelModule } from '@scania/tegel-angular-17';
import { ModalComponent } from '../../../../../shared/components/modal/modal.component';
import { InputComponent } from '../../../../../shared/components/input/input.component';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { CustomButtonComponent } from '../../../../../shared/components/custom-button/custom-button.component';
import { ButtonVariant } from '../../../../../shared/enums/button-variant.enum';
import { FaseId } from '../../../../../shared/enums/fase.enum';
import { ModalService } from '../../../../../shared/services/modal.service';

@Component({
  selector: 'app-dialog-lcb-produtivo',
  imports: [
    ButtonComponent,
    InputComponent,
    ModalComponent,
    TegelModule,
    ReactiveFormsModule,
    CustomButtonComponent,
  ],
  templateUrl: './dialog-lcb-produtivo.component.html',
  styleUrl: './dialog-lcb-produtivo.component.scss',
})
export class DialogLcbProdutivoComponent {
  public fase = FaseId;

  form: FormGroup;
  filaId: number;
  recebimentoId: number;

  constructor(
    private dialogRef: MatDialogRef<DialogLcbProdutivoComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private fb: FormBuilder,
    private workflowService: RecebimentoService,
    private toast: ToastService,
    private modal: ModalService,
  ) {
    this.filaId = data.id;
    this.recebimentoId = data.recebimentoId;

    const formattedDataEntrada = DateHelper.utcToLocalString(
      data.dataEntrada,
      'dd/MM/yyyy HH:mm:ss',
    );

    this.form = this.fb.group({
      senha: [data.recebimento.senha ?? ''],
      dataEntrada: formattedDataEntrada,
      registro: [data?.recebimento?.registro ?? ''],
      observacao: [data?.recebimento?.observacao ?? ''],
      critico: [data?.recebimento.critico ?? false],
      subidaDireta: [data?.recebimento.subidaDireta ?? false],
    });
  }

  processar(proximaFaseId: number) {
    if (this.form.invalid) {
      this.toast.showToast(ts.error, 'Formulário inválido.');
      return;
    }

    const formValues = this.form.value;

    const dto: LcbFilaProdEmb = {
      filaId: this.filaId,
      recebimentoId: this.recebimentoId,
      proximaFaseId: proximaFaseId,
      registro: formValues.registro,
      observacao: formValues.observacao,
      critico: formValues.critico,
      subidaDireta: formValues.subidaDireta,
    };

    if (proximaFaseId === FaseId.DAR_BAIXA) {
      this.openConfirmationDialog(dto);
    } else {
      this.executarProcessamento(dto);
    }
  }

  private openConfirmationDialog(dto: LcbFilaProdEmb) {
    const dialog = this.modal.openConfirmationModal(
      'Dar Baixa no Recebimento',
      'Você tem certeza que deseja dar baixa neste item?',
      'Sim',
      ButtonVariant.p,
      'Cancelar',
      ButtonVariant.s,
    );

    dialog.subscribe((result) => {
      if (result) {
        this.executarProcessamento(dto);
      }
    });
  }

  private executarProcessamento(dto: LcbFilaProdEmb) {
    this.workflowService.processamentoLcbProdEmb(dto).subscribe({
      next: (result) => {
        this.toast.showToast(ts.success, 'Processado com sucesso!');
        this.dialogRef.close(result.content);
      },
      error: (e) => this.toast.showToast(ts.error, e.error[0]),
    });
  }

  onClose() {
    this.dialogRef.close();
  }
}
